import { Decimal, ZERO } from '@snap-types/types/decimal';
import type { Nullish } from '@snap-types/types/nullish';

export function maybeDivide(
  numerator: Nullish<Decimal.Value>,
  denominator: Nullish<Decimal.Value>,
): Decimal {
  if (!numerator) {
    return ZERO;
  }

  const numeratorDecimal = new Decimal(numerator);

  if (denominator === null || denominator === undefined) {
    throw new Error(`Must provide a denominator, got: ${denominator}`);
  }

  const denominatorDecimal = new Decimal(denominator);

  if (denominatorDecimal.isZero()) {
    throw new Error('Denominator must not be zero');
  }

  return numeratorDecimal.dividedBy(denominatorDecimal);
}

export function maybeMultiply(
  left: Nullish<Decimal.Value>,
  right: Nullish<Decimal.Value>,
): Decimal {
  if (left && right) {
    return new Decimal(left).times(new Decimal(right));
  }

  return ZERO;
}
